// Krug 5 (K17.3): the energy in the header, `6/20`, with its pace on hover or tap:
// `+1 every 2h · next in 1h 10m · full in 12h`. Energy is a daily budget since K17. 1. 10. 2026 (C5): one
// pace and one maximum on every level.

import { energyRegenMinutes, type SurvivorSummaryDTO } from '@lastday/shared';
import { t } from '@/i18n';
import { clock as fmtClock, durationLabel, useCountdown } from '@/lib/format';
import { PathIcon, P } from './Icon';
import { LearnMore, Tip } from './Tip';

export function EnergyBadge({ s }: { s: SurvivorSummaryDTO }) {
  const nextMs = useCountdown(s.energyNextAt ?? null);
  const fullMs = useCountdown(s.energyFullAt ?? null);
  const hours = Math.round((energyRegenMinutes(s.level, Date.now(), s.energyCtx ?? {}) / 60) * 10) / 10;
  // 7. 10. 2026 (owner, energy test): the tip says the maximum too ("max 14").
  const pace = `${t('common.energyPace', { h: hours })} · ${t('common.energyMaxTip', { n: s.energyMax })}`;
  const tip = s.energyNextAt ? t('common.energyTip', { pace, next: durationLabel(nextMs), full: durationLabel(fullMs) }) : t('common.energyTipFull', { pace });
  return (
    <div className="relative flex flex-col items-end gap-0.5 pl-1">
      {/* 29. 9. 2026: the pace, and `Learn more` to the Guide's Energy. */}
      <Tip
        align="right"
        triggerTestId="energy-badge"
        label={`${t('common.energy')} ${s.energy}/${s.energyMax}. ${tip}`}
        triggerClassName="flex items-center gap-1 text-energy"
        tip={
          <span className="flex flex-col gap-1.5">
            <span data-testid="energy-tip" className="mono text-[12px]">
              {tip}
            </span>
            <LearnMore section="energy" className="self-start" />
          </span>
        }
      >
        <PathIcon d={P.energy} size={16} />
        <span className="mono text-[16px] font-bold text-energy">
          {s.energy}/{s.energyMax}
        </span>
      </Tip>
      <span className="mono text-[12px] text-muted">{s.energyNextAt ? t('common.plusIn', { t: fmtClock(nextMs) }) : t('common.full')}</span>
    </div>
  );
}
